import { render, staticRenderFns } from "./sales-new-user.vue?vue&type=template&id=8a75913c&scoped=true&lang=pug"
import script from "./sales-new-user.vue?vue&type=script&lang=ts"
export * from "./sales-new-user.vue?vue&type=script&lang=ts"
import style0 from "./sales-new-user.vue?vue&type=style&index=0&id=8a75913c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a75913c",
  null
  
)

export default component.exports